import DocumentMedia from './DocumentMedia';

export default DocumentMedia;
